export default {"src":"/_next/static/media/0x85955046df4668e1dd369d2de9f3aeb98dd2a369.fa2e870e.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};